// The count page's own hosts. CountAdviser (docs/decisions.md 2026-10-25) is countadviser.*; smartcount.* was its
// name until then and stays bound: once the new host is live the API answers it with a permanent redirect to
// countadviser.* (FASTCOUNT_HOST_REDIRECTS), so old links and phone installs keep working. Until then both serve the page.
export const isCountPageHost = (hostname: string): boolean =>
  hostname.startsWith('countadviser.') || hostname.startsWith('smartcount.');
